import { useMemo } from "react";
import { rtkqErrorToString } from "../../app/rtkQueryHelper";
import { Loading } from "../../components/Loading";
import AlertMessage, { AlertLevel } from "../../components/AlertMessage";
import Tabs, { SubTab } from "../../components/Tabs";
import SecretsTab from "./SecretsTab";
import ManagersTab from "./ManagersTab";
import { useGetSecretsStatusQuery } from "./secretsApiSlice";

enum AdminSecretsSubTabs {
	Secrets = "Secrets",
	Managers = "Managers",
}

/**
 * Key Vault secrets and who can manage them. People who can manage secrets get Secrets and
 * Managers sub-tabs; all other Super Administrators only see the Managers page.
 */
export default function AdminSecrets() {
	const { data, isLoading, error } = useGetSecretsStatusQuery();

	const subTabs: SubTab[] = useMemo(
		() =>
			!data
				? []
				: [
						{
							name: AdminSecretsSubTabs.Secrets,
							current: true,
							content: <SecretsTab data={data} />,
						},
						{
							name: AdminSecretsSubTabs.Managers,
							current: false,
							content: <ManagersTab data={data} />,
						},
					],
		[data]
	);

	return (
		<section>
			<h1 className="text-s sm:text-left w-full">Secrets</h1>
			<Loading loading={isLoading} />
			{error && (
				<AlertMessage
					className="my-4"
					type={AlertLevel.Error}
					message={rtkqErrorToString(error)}
					showIcon
				/>
			)}
			{data &&
				(data.canManageSecrets ? (
					<Tabs initialSubTabs={subTabs} ariaLabel="Secrets Tabs" />
				) : (
					<ManagersTab data={data} />
				))}
		</section>
	);
}
